
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/donor-portal/sign-in",
      function () {
        return require("private-next-pages/donor-portal/sign-in.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/donor-portal/sign-in"])
      });
    }
  